function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "oxv3u9sfaa"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 154450",
    style: {
      fill: "none"
    },
    d: "M0 0h36.271v33.173H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 5326"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 154451",
    style: {
      fill: "none"
    },
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 5325"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 154449",
    transform: "translate(2.164 3.607)",
    style: {
      fill: "#008ed1"
    },
    d: "M0 0h6.206v21.205H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 5324"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 5323",
    style: {
      clipPath: "url(#oxv3u9sfaa)"
    },
    transform: "translate(2 3.129)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 5538",
    d: "M18.3 0a10.358 10.358 0 0 1 7.65 3.245 10.691 10.691 0 0 1 3.192 7.768 10.639 10.639 0 0 1-3.215 7.816 10.641 10.641 0 0 1-7.816 3.215 10.618 10.618 0 0 1-7.8-3.23 10.621 10.621 0 0 1-3.23-7.8A10.535 10.535 0 0 1 10.337 3.2 10.928 10.928 0 0 1 18.3 0m-.187 6.183A4.367 4.367 0 0 0 14.836 7.6a4.761 4.761 0 0 0-1.354 3.413 4.749 4.749 0 0 0 1.362 3.417 4.509 4.509 0 0 0 6.552.007 4.761 4.761 0 0 0 1.347-3.424A4.764 4.764 0 0 0 21.4 7.59a4.374 4.374 0 0 0-3.284-1.407",
    transform: "translate(-2.686)",
    style: {
      fill: "#b6c91e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 5539",
    d: "M44.09 6.715v15.26h-6.207V6.715h-4.756V.77h15.7v5.945z",
    transform: "translate(-12.559 -.292)",
    style: {
      fill: "#008ed1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 5540",
    d: "M3.492 45.905a2.153 2.153 0 0 0 1.323-.324 1 1 0 0 0 .41-.814v-.145a.971.971 0 0 0-.43-.867 3.837 3.837 0 0 0-1.25-.47q-.6-.131-1.2-.278a3.852 3.852 0 0 1-1.085-.436 2.322 2.322 0 0 1-.787-.787 2.523 2.523 0 0 1-.3-1.329v-.173a2.618 2.618 0 0 1 .173-.906 2.391 2.391 0 0 1 .569-.866 3.048 3.048 0 0 1 1.052-.655 4.434 4.434 0 0 1 1.62-.258 6.835 6.835 0 0 1 1.522.166 4.6 4.6 0 0 1 1.455.628L5.767 39.7a3.469 3.469 0 0 0-1.084-.482 4.859 4.859 0 0 0-1.072-.118 2.573 2.573 0 0 0-.78.106 1.717 1.717 0 0 0-.549.278 1.187 1.187 0 0 0-.325.371.839.839 0 0 0-.106.4v.158a.877.877 0 0 0 .165.556 1.274 1.274 0 0 0 .444.35 2.869 2.869 0 0 0 .654.225q.377.086.8.178a6.829 6.829 0 0 1 1.422.456 3.329 3.329 0 0 1 .926.615 2.044 2.044 0 0 1 .5.761 2.639 2.639 0 0 1 .151.906v.172a2.818 2.818 0 0 1-.284 1.33 2.3 2.3 0 0 1-.775.859 3.289 3.289 0 0 1-1.123.464 6.246 6.246 0 0 1-1.324.138 5.95 5.95 0 0 1-1.007-.082 6.4 6.4 0 0 1-.933-.232 4.931 4.931 0 0 1-.812-.35 4.229 4.229 0 0 1-.655-.43l.82-1.35a4.187 4.187 0 0 0 2.673.926",
    transform: "translate(0 -14.253)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 5541",
    d: "M12.6 37.831h3.6a4.68 4.68 0 0 1 1.476.206 2.772 2.772 0 0 1 1.011.569 2.236 2.236 0 0 1 .588.867 3.014 3.014 0 0 1 .192 1.085v.278a3.088 3.088 0 0 1-.2 1.105 2.446 2.446 0 0 1-.609.913 3 3 0 0 1-1.018.622 4.053 4.053 0 0 1-1.442.232H14.3v3.662h-1.7zm1.7 1.416v3.03h1.679a2.339 2.339 0 0 0 1.309-.317 1.282 1.282 0 0 0 .477-1.151v-.239a1.51 1.51 0 0 0-.119-.648 1.009 1.009 0 0 0-.338-.4 1.335 1.335 0 0 0-.522-.211 3.4 3.4 0 0 0-.662-.06z",
    transform: "translate(-4.779 -14.342)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 5542",
    d: "M30.257 47.37h-1.84l-.925-2.62h-3.214l-.94 2.62H21.6l3.546-9.539h1.521zm-5.491-4.035H27l-.648-1.945a17.382 17.382 0 0 1-.272-.8l-.2-.668c-.037.133-.069.251-.1.358s-.065.214-.1.324l-.113.35c-.04.123-.091.269-.151.436z",
    transform: "translate(-8.191 -14.342)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 5543",
    d: "M39.166 37.6a6.056 6.056 0 0 1 1.78.238 4.558 4.558 0 0 1 1.5.82l-.913 1.3a3.042 3.042 0 0 0-1.15-.641 4.726 4.726 0 0 0-1.218-.152 2.824 2.824 0 0 0-.833.125 1.7 1.7 0 0 0-.728.456 2.454 2.454 0 0 0-.517.9 4.5 4.5 0 0 0-.2 1.455v.979a3.912 3.912 0 0 0 .186 1.284 2.362 2.362 0 0 0 .5.859 1.859 1.859 0 0 0 .72.483 2.441 2.441 0 0 0 .861.153 4.765 4.765 0 0 0 1.356-.206 2.91 2.91 0 0 0 1.263-.787l.9 1.3a3.638 3.638 0 0 1-.892.668 5.394 5.394 0 0 1-.933.384 4.591 4.591 0 0 1-.913.179q-.449.039-.846.039A4.9 4.9 0 0 1 37.6 47.2a3.288 3.288 0 0 1-1.243-.715 3.473 3.473 0 0 1-.854-1.244 4.7 4.7 0 0 1-.318-1.825v-1.704a4.967 4.967 0 0 1 .31-1.845 3.553 3.553 0 0 1 .855-1.283 3.363 3.363 0 0 1 1.262-.748 4.926 4.926 0 0 1 1.555-.238",
    transform: "translate(-13.339 -14.254)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 5544",
    d: "M54.453 37.831v1.4h-4.459V41.8h4.182v1.376h-4.182v2.793h4.552v1.4h-6.232v-9.538z",
    transform: "translate(-18.317 -14.342)",
    style: {
      fill: "#fff"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoShort);
export default __webpack_public_path__ + "static/media/logo_short.480f967583469380aab08490cb095888.svg";
export { ForwardRef as ReactComponent };